import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//import { addFilter } from '../../common/services/navigation';
import SearchInput from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';
//import DropdownTreeSelect from 'react-dropdown-tree-select';
import TAPsDropdown from './TWIInnovationNetworkTAPsDropdownJsFile';
import { Configuration } from '../../config';


function TWIInnovationNetworkTAPsListingTopComponent({ search, settings }) {

    const [industries, setIndustries] = useState([]);
    const [topics, setTopics] = useState([]);

    const dedupe = (array) => {
		return [...new Set(array)];
	}

    useEffect(() => {
		fetch(Configuration.rootUrl+'/api/delivery/projects/website/entries/search?accessToken=D8wMky9p2x41vFHrR8MVV3bOWg7UCpolPYQTVMzoySnGJTx5', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				pageIndex: 0,
				pageSize: 500,
				fields: ["multipleChoice", "multipleChoice1"],
				where: [
					{
						field: "sys.versionStatus",
						equalTo: "latest"
					},
					{
						field: "sys.contentTypeId",
						equalTo: "taps"
					},
					{
						"and": [
							{
								"field": "multipleChoice",
								"exists": true
							},
							{
								"field": "multipleChoice1",
								"exists": true
							}
						]
					}
					]}),

			})
			.then(response => response.json())
			.then(data => 	{

                // let industries = data.items.map(item => item.multipleChoice.trimStart());

				// let topics = data.items.map(item =>  item.multipleChoice1.trimStart());

                let industries = data.items.map(item => item.multipleChoice);

				let topics = data.items.map(item =>  item.multipleChoice1);


                industries = [].concat(...industries);

                topics = [].concat(...topics);

				

				//locationList = groupBy(locationList);

				industries = dedupe(industries);
				topics = dedupe(topics);


				industries.sort();
				topics.sort();


				//locationList = groupBywithCount(locationList);

                setIndustries(industries);
                setTopics(topics);



				console.log(industries);
				console.log(topics);

			})
			.catch(error => console.error(error));
	}, []);

	return (
        <div className="filter-bar core-research large-12">
            <div className="filter__text">
                Filter by
            </div>

            <SearchInput search={search} settings={settings}/>

            <TAPsDropdown search={search} title='Industries' options={industries} name='Industries' />

            <TAPsDropdown search={search} title='Topics' options={topics} settings={settings} name='Topics'/>

        </div>
	);
}

TWIInnovationNetworkTAPsListingTopComponent.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object
};

export default TWIInnovationNetworkTAPsListingTopComponent;
